__turbopack_context__.v({
  "glow": "AnimatedNumber-module-scss-module__Yc0VFa__glow",
  "number": "AnimatedNumber-module-scss-module__Yc0VFa__number",
  "pulse": "AnimatedNumber-module-scss-module__Yc0VFa__pulse",
});
